import axios from "axios";

const API_URL =
  process.env.REACT_APP_V2_PUBLIC_API_URL || "http://localhost:8000";

export const publicApi = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": process.env.REACT_APP_X_API_KEY_PUBLIC,
  },
});

// Call types
export interface OutboundCallResponse {
  call_id: number;
  exotel_call_sid: string;
  status: string;
  phone_number: string;
  direction: string;
}

export interface AgentVariablePublic {
  id: string;
  name: string;
  source: string;
  // multiple: several options can be picked; they're sent as one
  // comma-separated value ("a, b"). Absent = single pick.
  options?: { values: string[]; multiple?: boolean } | null;
  depends_on?: { variables: string[] } | null;
  description: string | null;
  is_required: boolean;
  default_value: string | null;
  variable_type: string;
  computation_expression?: string | null;
  default_value_expression?: string | null;
}

export interface AgentPlanPublic {
  id: string;
  name: string;
  description: string | null;
  is_default: boolean;
  variables?: AgentVariablePublic[] | null;
}

export interface AgentDetailPublic {
  id: string;
  name: string;
  description: string | null;
  is_active: boolean;
  is_multi_plan: boolean;
  v2_variables: AgentVariablePublic[];
  plans: AgentPlanPublic[];
  backend_json: any;
}

export const publicTestApi = {
  // Get agent details with variables
  getAgentDetail: async (agentId: string): Promise<AgentDetailPublic> => {
    const response = await publicApi.get(
      `call_flows/flows/${agentId}/combined/`,
    );
    return response.data;
  },
};
